import { FormItemPropTypes } from '../form-item/default.js'

const FormItemMediaImagePropTypes = {
  ...FormItemPropTypes,
}

export default FormItemMediaImagePropTypes
